import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FaPlus, FaMotorcycle } from 'react-icons/fa'
import { getAllRiders } from '../../../store/actions/riders'
import { Button } from '../../../UI'
import AddRiderSelectionModal from './AddRiderSelectionModal'
import AddExistingRiderModal from './AddExistingRiderModal'
import RiderForm from './RiderForm'
import RiderListItem from './RiderListItem'
import RiderDetails from './RiderDetails'
import Container from './styles'

const Riders = () => {
  const dispatch = useDispatch()
  const riderData = useSelector((s) => s.RiderData || { data: [] })
  const riders = riderData.data || []
  const [showSelection, setShowSelection] = useState(false)
  const [showExistingForm, setShowExistingForm] = useState(false)
  const [showNewForm, setShowNewForm] = useState(false)
  const [showDetails, setShowDetails] = useState(false)
  const [selectedRider, setSelectedRider] = useState(null)
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    dispatch(getAllRiders())
  }, [dispatch])

  const handleSearch = (e) => {
    const value = e.target.value
    setSearchTerm(value)
    dispatch(getAllRiders(1, 10, value))
  }

  const handleRiderClick = (rider) => {
    setSelectedRider(rider)
    setShowDetails(true)
  }

  const openAddRiderSelection = () => {
    setShowSelection(true)
  }

  const openExistingRiderForm = () => {
    setShowExistingForm(true)
  }

  const openNewRiderForm = () => {
    setShowNewForm(true)
  }

  return (
    <Container>
      <header>
        <div className="top--row">
          <h2>Riders Management</h2>
        </div>
        <div className="header--row">
          <div>
            <input 
              type="search" 
              placeholder="Search riders..." 
              className="search-input"
              value={searchTerm}
              onChange={handleSearch}
            />
          </div>
          <Button className="add--btn" onClick={openAddRiderSelection}>
            <FaPlus className="icon" />
            <span>Add Rider</span>
          </Button>
        </div>
      </header>

      <div className="content--container">
        {riders.length === 0 ? (
          <div className="empty--container">
            <FaMotorcycle style={{ fontSize: '4rem', color: 'rgba(255, 255, 255, 0.3)' }} />
            <h3>No Riders Yet</h3>
            <p className="instruction">
              Add riders to handle deliveries for your company
            </p>
            <Button className="add--btn" onClick={openAddRiderSelection}>
              <FaPlus className="icon" />
              Add First Rider
            </Button>
          </div>
        ) : (
          <div className="riders--grid">
            {riders.map((rider) => (
              <div key={rider.id} onClick={() => handleRiderClick(rider)}>
                <RiderListItem rider={rider} />
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Modals */}
      {showSelection && (
        <AddRiderSelectionModal 
          show={showSelection} 
          handleClose={() => setShowSelection(false)}
          onSelectExisting={openExistingRiderForm}
          onSelectNew={openNewRiderForm}
        />
      )}

      {showExistingForm && (
        <AddExistingRiderModal 
          show={showExistingForm} 
          handleClose={() => setShowExistingForm(false)} 
        />
      )}

      {showNewForm && (
        <RiderForm 
          show={showNewForm} 
          handleClose={() => setShowNewForm(false)} 
        />
      )}

      {showDetails && (
        <RiderDetails 
          show={showDetails} 
          handleClose={() => {
            setShowDetails(false)
            setSelectedRider(null)
          }} 
          rider={selectedRider} 
        />
      )}
    </Container>
  )
}

export default Riders
